import { DAY_MS, DAY_SEC, HOUR_MS, HOUR_SEC } from '@/constants/time'
import { isNumber } from '@/util/validators/baseComponentsValidators'

/** ms */
export const msToHours = (ms) => Math.trunc(ms / HOUR_MS)
export const msToDays = (ms) => Math.trunc(ms / DAY_MS)
/** sec */
export const secToHours = (sec, isTruncOrNumbersAfterDot = true) => {
  /** isTruncOrNumbersAfterDot: number | boolean */
  const divided = sec / HOUR_SEC
  if (isTruncOrNumbersAfterDot === true) {
    return Math.trunc(divided)
  }
  else if (isTruncOrNumbersAfterDot === false) {
    return divided
  }
  else if (isNumber(isTruncOrNumbersAfterDot)) {
    const [integer, floatPart] = divided.toString().split('.')
    return parseFloat(`${integer}${floatPart ? `.${floatPart.slice(0, isTruncOrNumbersAfterDot)}` : ''}`)
  }
  else {
    console.warn('secToHours got invalid isTruncOrNumbersAfterDot, expected Boolean or Number, got: ', isTruncOrNumbersAfterDot)
  }
}
export const secToDays = (sec) => Math.trunc(sec / DAY_SEC)
export const secToMin = (sec) => Math.trunc(sec / 60)
export async function wait(ms = 0) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const measure = async (fn, args = []) => {
  const start = new Date()
  const res = await fn(...args)
  const end = new Date()
  return [res, end - start]
}
export function logWarn(message, error = null) {
  console.warn(`Slots City message: ${message}${error ? `\nSlots City Error: ${error}` : ''}`)
}
